import React from "react";
import { Popover, Avatar, Row } from "antd";
import { UserOutlined, PhoneOutlined, MailOutlined } from "@ant-design/icons";
import Username from "./Username";
import metaData from "../../../../data/metaData";

const ClientInfo = ({ user }) => {
  if (!user) return null;

  return (
    <Popover
      content={
        <div>
          <p>
            <PhoneOutlined style={{ marginRight: 12 }} />
            {user.tel}
          </p>
          <p>
            <MailOutlined style={{ marginRight: 12 }} />
            {user.email}
          </p>
        </div>
      }
      title={
        <Row justify="start" align="middle">
          {user.avatar ? (
            <Avatar
              src={`${metaData.blobPreURL}clientUpload-${user.avatar}.jpeg${metaData.blobPostURL}`}
              size={45}
              style={{ marginRight: 10 }}
            />
          ) : (
            <Avatar icon={<UserOutlined />} size={45} style={{ marginRight: 10 }} />
          )}
          <Username user={user} />
        </Row>
      }
      trigger="hover"
    >
      <a>
        <Username user={user} />
      </a>
    </Popover>
  );
};

export default ClientInfo;
